import { PageConfigService } from './../../page-config.service';
import { Component, OnInit } from '@angular/core';
import { UserApiService } from '../../user-api.service';
import {  CookieService} from 'ngx-cookie-service';


@Component({
  selector: 'app-cgu',
  templateUrl: './cgu.component.html',
  styleUrls: ['./cgu.component.scss']
})
export class CguComponent implements OnInit {

  constructor(private cookieService: CookieService, private apiService : UserApiService, private PageConfigService : PageConfigService ) 
  {  this.PageConfigService.config.subscribe((x) =>{this.UrlCGU = x.cgu}) }

  cguOffline : any;
  cguONline : any;

  UrlCGU : string;
  ngOnInit() {
   this.subscribeToCGU();
    
  }




//sbscribe incidents
subscribeToCGU() {
  if (localStorage.getItem('token_clem_mobi')) {
    return this.apiService.getCGUisAthentificate().subscribe((res)=>{
     this.cguONline = res.data
    //  console.log(res.data) 
    });
  }
  return this.apiService.getCGU(this.UrlCGU).subscribe((res)=>{
    // console.log(res.data);
    this.cguOffline = res.data
   });
  
}


}
